import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { IconButton, Dialog, DialogTitle, TableContainer, Tab, TabPanel, TabList, Tabs, Drawer, Paper, Typography, Table, TableHead, TableRow, TableCell, TableBody, DialogContent, DialogActions, Tooltip } from '@mui/material'
import { ChevronLeft } from '@mui/icons-material'
import { Button } from '@mui/material'
import { DateRange, Close, Cancel } from '@mui/icons-material'
import WeeklyRecommendationStore from '../DataRepository/WeeklyRecommendation';
import { DateRangePicker } from 'materialui-daterange-picker';
import { styled } from "@mui/material/styles";
import LoadingComponent from '../loading';
import YogaIcon from '../Assets/images/Yoga 3.png'
import PranayamaIcon from '../Assets/images/Pranayama 4.png'
import MeditationIcon from '../Assets/images/Meditation 3.png'
import RecipesIcon from '../Assets/images/Breakfast 1.png'
import MedicinesIcon from '../Assets/images/Medicine 1.png'
import MidDayDrinkIcon from '../Assets/images/Snacks 1.png'
import CheckCircle from '../Assets/images/right.png'
import RemoveCircle from '../Assets/images/Wrong.png'
import WarningIcon from '../Assets/images/exclamatory 1.png'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const DailyLogging = () => {

    const { getWeeklyRecommendationData, WeeklyRecommendationData, isWeeklyRecommendationLoading } = WeeklyRecommendationStore();

    const { UID } = useLocation().state;

    const [startDate, setStartDate] = useState();

    const [endDate, setEndDate] = useState();

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const [openSideDrawer, setOpenSideDrawer] = useState(false);

    const [selectedActivity, setSelectedActivity] = useState(null);

    const [dateRange, setDateRange] = useState({
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date()
    });

    const [selectedTab, setSelectedTab] = useState(0); // Morning by default

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        const labels = ['morning', 'afternoon', 'evening', 'night'];

    };

    const tabLabels = ['Morning', 'Afternoon', 'Evening', 'Night'];

    useEffect(() => {
        getWeeklyRecommendationData(UID, startDate, endDate);
    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(!open);
    };

    const handleDateRangeChange = (range) => {
        setDateRange(range);
    };

    const handleSaveChanges = async () => {
        await getWeeklyRecommendationData(UID, dateRange.startDate.toISOString(), dateRange.endDate.toISOString());
        setOpen(false);

    };

    const getStatus = (lineItems = [], key) => {
        if (!Array.isArray(lineItems) || !key) return null;
      
        let foundArray = false;
      
        for (const item of lineItems) {
          const arr = item?.[key];
          if (Array.isArray(arr) && arr.length > 0) {
            foundArray = true;
            if (arr.some(sub => sub?.taken === true)) {
              return true; 
            }
          }
        }
      
        if (foundArray) return false;
      
        return null;
      };
      

    const generateTimeSlotHeaders = (weeklyData) => {
        const timeSlotHeaders = {};

        if (!weeklyData || !Array.isArray(weeklyData) || weeklyData.length === 0) {
            return {
                morning: ["yoga", "pranayama", "meditation", "recipes", "beforemedicines", "medicines"],
                afternoon: ["recipes", "beforemedicines", "medicines"],
                evening: ["pranayama", "meditation", "recipes"],
                night: ["recipes", "beforemedicines", "medicines"]
            };
        }

        weeklyData.forEach(entry => {
            if (entry.Activity && Array.isArray(entry.Activity)) {
                entry.Activity.forEach(activity => {
                    const timing = activity.timing;
                    if (!timeSlotHeaders[timing]) {
                        timeSlotHeaders[timing] = new Set();
                    }

                    activity.lineItems?.forEach(lineItem => {
                        Object.keys(lineItem).forEach(key => {
                            if (!['timing', 'completed', 'createdAt', 'updatedAt'].includes(key) &&
                                lineItem[key] &&
                                Array.isArray(lineItem[key]) &&
                                lineItem[key].length > 0) {
                                timeSlotHeaders[timing].add(key);
                            }
                        });
                    });
                });
            }
        });

        Object.keys(timeSlotHeaders).forEach(timing => {
            timeSlotHeaders[timing] = Array.from(timeSlotHeaders[timing]);
        });


        if (Object.keys(timeSlotHeaders).length === 0) {
            return {
                morning: ["yoga", "pranayama", "meditation", "recipes", "beforemedicines", "medicines"],
                afternoon: ["recipes", "beforemedicines", "medicines"],
                evening: ["pranayama", "meditation", "recipes"],
                night: ["recipes", "beforemedicines", "medicines"]
            };
        }

        return timeSlotHeaders;
    };

    const timeSlotHeaders = generateTimeSlotHeaders(WeeklyRecommendationData);

    const icons = {
        yoga: <div className='w-15 h-15 flex items-center justify-center p-1 border rounded' style={{ backgroundColor: '#FFD5AE66' }} title="Yoga"><img src={YogaIcon} alt="Yoga" style={{ width: '24px', height: '24px', objectFit: 'contain' }} /></div>,
        pranayama: <div className='w-15 h-15 flex items-center justify-center p-1 border rounded' style={{ backgroundColor: '#FFD5AE66' }} title="Pranayama"><img src={PranayamaIcon} alt="Pranayama" style={{ width: '24px', height: '24px', objectFit: 'contain' }} /></div>,
        meditation: <div className='w-15 h-15 flex items-center justify-center p-1 border rounded' style={{ backgroundColor: '#FFD5AE66' }} title="Meditation"><img src={MeditationIcon} alt="Meditation" style={{ width: '24px', height: '24px', objectFit: 'contain' }} /></div>,
        recipes: <div className='w-15 h-15 flex items-center justify-center p-1 border rounded' style={{ backgroundColor: '#FFD5AE66' }} title="Recipes"><img src={RecipesIcon} alt="Recipes" style={{ width: '24px', height: '24px', objectFit: 'contain' }} /></div>,
        beforemedicines: <div className='w-15 h-15 flex items-center justify-center p-1 border rounded' style={{ backgroundColor: '#FFD5AE66' }} title="Before Medicines"><img src={MedicinesIcon} alt="Before Medicines" style={{ width: '24px', height: '24px', objectFit: 'contain' }} /></div>,
        medicines: <div className='w-15 h-15 flex items-center justify-center p-1 border rounded' style={{ backgroundColor: '#FFD5AE66' }} title="Medicines"><img src={MedicinesIcon} alt="Medicines" style={{ width: '24px', height: '24px', objectFit: 'contain' }} /></div>,
        midDayDrink: <div className='w-15 h-15 flex items-center justify-center p-1 border rounded' style={{ backgroundColor: '#FFD5AE66' }} title="Mid Day Drink"><img src={MidDayDrinkIcon} alt="MidDayDrink" style={{ width: '24px', height: '24px', objectFit: 'contain' }} /></div>,
    };

    const StatusIcon = ({ completed }) => {
        let icon, label;


        if (completed === true) {
            icon = CheckCircle;
            label = 'Completed';
        } else if (completed === false) {
            icon = RemoveCircle;
            label = 'Not Taken';
        } else if (completed === null) {
            icon = WarningIcon;
            label = 'Not Prescribed';
        }

        return (
            <Tooltip title={label} arrow placement="top">
                <div className='w-15 h-15 flex items-center justify-center cursor-help'>
                    <img
                        src={icon}
                        alt={label}
                        style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                    />
                </div>
            </Tooltip>
        );
    };

    const handleSelectActivity = (activity) => {
        setSelectedActivity(activity);
        setOpenSideDrawer(true);
    };

    const handleCloseDrawer = () => {
        setOpenSideDrawer(false);
    };

    const activity = selectedActivity?.Activity[selectedTab];

    const mealLabels = {
        morning: 'Breakfast',
        afternoon: 'Lunch',
        evening: 'Snacks',
        night: 'Dinner',
    };

    return (
        <div className='w-full box-border'>
            <LoadingComponent loading={isWeeklyRecommendationLoading} />
            <div className="Patient_Profile w-full box-border">
                <nav className=" w-full  shadow-md border rounded-lg px-4 py-2">
                    <div className="flex justify-between items-center max-w-full flex-wrap">

                        <div className="flex items-center flex-shrink-0 mr-4" onClick={() => navigate(-1)}>
                            <IconButton>
                                <ChevronLeft />
                            </IconButton>
                            <p className="ml-2 text-lg font-medium whitespace-nowrap">Daily Logging</p>
                        </div>

                        <div className="flex-shrink-0">
                            <Button
                                className="flex items-center border !border-amber-600 !text-amber-600 rounded px-4 py-2 text-sm font-medium whitespace-nowrap"
                                onClick={handleClickOpen}
                            >
                                <DateRange className="mr-2" /> Sort by Date
                            </Button>
                        </div>

                    </div>
                </nav>



                <div className='mt-10' style={{ height: 'calc(100vh - 200px)' }}>
                    <TableContainer component={Paper} sx={{
                        height: '100%',
                        borderRadius: '10px',
                        border: '1px solid #B9B9B9',
                        boxShadow: 'none',
                        overflow: 'auto',
                    }}>
                        <Table stickyHeader size="small" sx={{
                            minWidth: 650,
                            '& td, & th': {
                                border: '1.5px solid #e0e0e0 !important',
                                fontFamily: "'Poppins', sans-serif !important",
                                fontWeight: 500,
                                color: '#3B3629 !important'
                            },
                        }}>
                            <TableHead>

                                <TableRow>
                                    <TableCell
                                        align="center"
                                        rowSpan={2}
                                        sx={{
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 3,
                                            backgroundColor: '#EFEFE7',
                                            fontWeight: 'bold',
                                            fontSize: '14px',
                                            border: '5px solid #B9B9B9 !important',
                                            color: '#3B3629'
                                        }}
                                    >
                                        Date / Timing
                                    </TableCell>
                                    {Object.entries(timeSlotHeaders).map(([slot, types]) => (
                                        <TableCell
                                            key={slot}
                                            colSpan={types.length}
                                            align="center"
                                            sx={{
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 2,
                                                backgroundColor: '#EFEFE7',
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                textTransform: 'capitalize',
                                                border: '2px solid #B9B9B9 !important',
                                                color: '#3B3629'
                                            }}
                                        >
                                            {slot === 'afternoon' ? 'Lunch' : slot}
                                        </TableCell>
                                    ))}
                                </TableRow>


                                <TableRow>
                                    {Object.entries(timeSlotHeaders).flatMap(([slot, types]) =>
                                        types.map(type => (
                                            <TableCell
                                                key={`${slot}-${type}`}
                                                align="center"
                                                sx={{
                                                    position: 'sticky',
                                                    top: 35,
                                                    zIndex: 1,
                                                    backgroundColor: '#FFFFFF',
                                                    border: '1px solid #e0e0e0',
                                                    padding: '8px'
                                                }}
                                            >
                                                <Tooltip
                                                    title={type.charAt(0).toUpperCase() + type.slice(1).replace('medicines', ' Medicines')}
                                                    arrow
                                                    placement="top"
                                                >
                                                    <div style={{ cursor: 'help' }}>
                                                        {icons[type] || type}
                                                    </div>
                                                </Tooltip>
                                            </TableCell>
                                        ))
                                    )}
                                </TableRow>
                            </TableHead>


                            <TableBody>
                                {WeeklyRecommendationData.map((entry, idx) => {

                                    const date = new Date(entry.archivedAt).toLocaleDateString("en-GB");

                                    const activityBySlot = {};

                                    if (entry.Activity) {
                                        entry.Activity.forEach(slot => {
                                            activityBySlot[slot.timing] = slot.lineItems;
                                        });
                                    }

                                    return (
                                        <TableRow key={idx}>
                                            <TableCell sx={{ fontWeight: 'bold' }} align="center" onClick={() => { handleSelectActivity(entry) }}>{date}</TableCell>
                                            {Object.entries(timeSlotHeaders).flatMap(([slot, types]) =>
                                                types.map(type => {
                                                    const lineItems = activityBySlot[slot] || [];
                                                    const completed = getStatus(lineItems, type);
                                                    return (
                                                        <TableCell align="center" key={`${idx}-${slot}-${type}`}>
                                                            <StatusIcon completed={completed} />
                                                        </TableCell>
                                                    );
                                                })
                                            )}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>


                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    fullWidth
                    maxWidth="lg"
                >
                    <DialogTitle
                        sx={{
                            m: 0,
                            p: 2,
                            position: 'relative',
                        }}
                        id="customized-dialog-title"
                    >
                        Select Date Range


                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={(theme) => ({
                                position: "absolute",
                                right: 8,
                                top: 8,
                                color: theme.palette.grey[500],
                            })}
                        >
                            <Close />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                        {open &&
                            <DateRangePicker
                                open={true}
                                onChange={handleDateRangeChange}
                                initialDateRange={{
                                    startDate: dateRange.startDate,
                                    endDate: dateRange.endDate,
                                }}
                            />
                        }

                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button autoFocus onClick={handleSaveChanges}>Save Changes</Button>
                    </DialogActions>
                </BootstrapDialog>


                <Drawer
                    anchor="right"
                    open={openSideDrawer}
                    onClose={() => setOpenSideDrawer(false)}
                >
                    <div className="w-full h-full p-4 max-w-[650px] overflow-x-hidden">
                        <div className="flex justify-between items-center mb-4 bg-[#FAF6EC] py-2 px-4 rounded-lg">
                            <p className="text-md font-semibold">{
                                new Date(selectedActivity?.archivedAt).toLocaleDateString("en-GB")
                            }</p>

                            <button
                                onClick={() => setOpenSideDrawer(false)}
                                className="text-gray-600 hover:text-gray-800"
                            >
                                Close
                            </button>

                        </div>

                        <div>
                            <Tabs
                                value={selectedTab}
                                onChange={handleTabChange}
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                                TabIndicatorProps={{ style: { display: 'none' } }}
                                sx={{
                                    '& .MuiTabs-indicator': {
                                        display: 'none',
                                    },
                                    '& .MuiTab-root': {
                                        textTransform: 'none',
                                        padding: '10px',
                                        paddingX: '2rem',
                                        borderRadius: '4px',
                                        fontFamily: "'Poppins', sans-serif",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                        border: '1px solid #ccc',
                                        margin: '0 2px',
                                        minWidth: 0,
                                        minHeight: 0,
                                        backgroundColor: '#EFEFE7',
                                        color: "#A5A39D",
                                        '&.Mui-selected': {
                                            backgroundColor: '#75623F',
                                            color: '#FDFDFD',
                                        },
                                    },
                                }}
                            >
                                {tabLabels.map((label, index) => (
                                    <Tab
                                        key={label}
                                        label={label}

                                    />
                                ))}
                            </Tabs>
                        </div>

                        <div className="flex flex-col gap-4 overflow-x-hidden">
                            {activity?.lineItems?.map((item, index) => (
                                <div key={index} className="border p-4 rounded-lg shadow-sm bg-[#EFEFE799] ">

                                    <h3 className="text-sm font-semibold text-gray-800 mb-2">
                                        {item.timing}
                                    </h3>


                                    {item.medicines?.some((med) => med?.taken) && (
                                        <div className="flex flex-row items-center gap-4 mt-4">
                                            <p className="font-semibold text-gray-800">Medicines</p>
                                            <div className="flex flex-row items-center gap-2 overflow-x-auto">
                                                {item.medicines
                                                    .filter((med) => med?.taken)
                                                    .map((med, medIndex) => (
                                                        <div
                                                            key={medIndex}
                                                            className="text-sm flex flex-col items-center
                                                          gap-2 shrink-0 w-[120px] text-center text-green-700"
                                                        >
                                                            {med?.id != '' ?
                                                                <img src={med?.imgurl} alt="Medicine Image" className='w-14 h-14 object-cover rounded-sm' ></img>
                                                                :
                                                                <img src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png" alt="Medicine Image" />
                                                            }
                                                            {med?.medicine}
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}

                                    {item.meditation?.some((m) => m?.taken) && (
                                        <div className="flex flex-row items-center gap-4">
                                            <p className="font-semibold text-gray-800">Meditation</p>
                                            <div className="flex flex-row items-center gap-2 overflow-x-auto">
                                                {item.meditation
                                                    .filter((m) => m?.taken)
                                                    .map((m, mIndex) => (
                                                        <div
                                                            key={mIndex}
                                                            className="text-sm flex flex-col items-center gap-2 shrink-0 w-[120px] text-center"
                                                        >
                                                            <img
                                                                src={m?.image}
                                                                alt={m?.title}
                                                                className="w-14 h-14 object-cover"
                                                            />
                                                            <p>{m?.title}</p>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}

                                    {item.pranayama?.some((y) => y?.taken) && (
                                        <div className="flex flex-row items-center gap-4">
                                            <p className="font-semibold text-gray-800">Pranayama</p>
                                            <div className="flex flex-row items-center gap-2 overflow-x-auto">
                                                {item.pranayama
                                                    .filter((y) => y?.taken)
                                                    .map((y, yIndex) => (
                                                        <div
                                                            key={yIndex}
                                                            className="text-sm flex flex-col items-center gap-2 shrink-0 w-[120px] text-center"
                                                        >
                                                            <img
                                                                src={y?.image}
                                                                alt={y?.title}
                                                                className="w-14 h-14 object-cover"
                                                            />
                                                            <p>{y?.title}</p>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}

                                    {item.yoga?.some((y) => y?.taken) && (
                                        <div className="flex flex-row items-center gap-4">
                                            <p className="font-semibold text-gray-800">Yoga</p>
                                            <div className="flex flex-row items-center gap-2 overflow-x-auto">
                                                {item.yoga
                                                    .filter((y) => y?.taken)
                                                    .map((y, yIndex) => (
                                                        <div
                                                            key={yIndex}
                                                            className="text-sm flex flex-col items-center gap-2 shrink-0 w-[120px] text-center"
                                                        >
                                                            <img src={y?.image} alt={y?.title} className="w-14 h-14 object-cover" />
                                                            <p>{y?.title}</p>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}

                                    {item.recipes?.some((r) => r?.taken) && (
                                        <div className="flex flex-row items-center gap-4">
                                            <p className="font-semibold text-gray-800">{mealLabels[activity?.timing]}</p>
                                            <div className='flex flex-row items-stretch gap-2 overflow-x-auto'>
                                                {item.recipes
                                                    .filter((r) => r?.taken)
                                                    .map((r, rIndex) => (
                                                        <div key={rIndex} className="text-sm flex flex-col items-center gap-2 shrink-0 w-[120px] text-center">
                                                            <img src={r?.imageLink} alt="" className="w-14 h-14 object-cover rounded-full" />
                                                            <p>{r.recipe}</p>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    )}

                                </div>
                            ))}
                        </div>

                    </div>
                </Drawer>
            </div >
        </div >
    )
}

export default DailyLogging
